module.exports = __webpack_public_path__ + "static/tools-resources-hero-a6bfd9239c0b95cbb0327f96a4599631.jpg";